module.exports = __webpack_public_path__ + "static/1407355865.bf460d60.jpg";